<div class="modal-apollo">
	<div class="modal-apollo__container">
		<div class="modal-apollo__info">
      <p><strong>OCR</strong> stands for <strong>Optical Character Recognition</strong>. It is a technique that uses templates of letters to identify which words are present in an image or any other file where the text has been outlined (or converted to graphics).
<strong>OCR</strong> works best when:</p>
      <ul class="modal-apollo__list">
          <li>You know the <strong>language</strong> of the text.</li>
          <li>The text is in <strong>normal reading direction</strong> .</li>
          <li>The image has the <strong>right resolution</strong>. </li>
      </ul>
      <p>You can use <strong>OCR</strong> within <strong>XRAY</strong>. We do our best to optimise the results, but here are some tips for you to explore the possibilities:</p>
      <ul class="modal-apollo__list list_style" >
          <li>Do <strong>not</strong> attempt to extract <strong>OCR</strong> over many pages of very long documents, it can take a long time and results might not be what you expect.</li>
          <li><strong>OCR</strong> is well suited for <strong>clear text over white or single color </strong>background.</li>
          <li>Extracting <strong>text in logos</strong> or text with a log of embellishment is very difficult.</li>
          <li><strong>OCR</strong> will work great in <strong>single flaps</strong> of folding boxes, labels, etc.</li>
      </ul>
      <p>Our recommendation is that you experiment a bit until you get the hang of it. If you have questions, feel free to ask for <strong class="help">Help </strong> <strong>(Help Me Button)</strong> and we will be delighted to assist.</p>
    </div>
		<div class="modal-apollo__btn_text">
			<core-helpers-forms-button-white class="compare-action" [text]="'Close'" (submit)="actionButton('dismiss')"></core-helpers-forms-button-white>
		</div>
	</div>
</div>
